import { FollowService } from '@/service/FollowService'
import { reactive } from 'vue'

export class FollowsState {
  state = reactive({
    followMap: {} as Record<string, boolean>,
  })

  async followUser(userId: string): Promise<boolean> {
    await FollowService.followUser(userId)
    this.state.followMap[userId] = true
    return true
  }

  async isFollowing(userId: string): Promise<boolean> {
    try {
      if (this.state.followMap[userId]) {
        return true
      }
      const followInfo = await FollowService.getFollowInfo(userId)
      this.state.followMap[userId] = !!followInfo
      return this.state.followMap[userId]
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async unfollowUser(userId: string): Promise<boolean> {
    await FollowService.unfollowUser(userId)
    this.state.followMap[userId] = false
    return true
  }
}

export const FollowState = new FollowsState()
